<template>
    <v-app class="tw-overflow-x-hidden tw-max-w-full tw-w-full">
        <router-view />
    </v-app>
</template>

<script lang="ts" setup></script>
